import { getUser } from 'core_main/api/users';
import { getUserFromStore } from 'core_main/store';
import Pubnub from 'pubnub';
import { runListenersForUserTypingEvent } from '../helpers/userTyping';

export const handleUserTypingEvent = (
  signalEvent: Pubnub.SignalEvent,
  typingOpts,
) => {
  const user = getUserFromStore(signalEvent.publisher);

  if (user) {
    runListenersForUserTypingEvent(signalEvent, user, typingOpts);
  } else {
    getUser(signalEvent.publisher).then((res) => {
      runListenersForUserTypingEvent(
        signalEvent,
        res.data.attributes,
        typingOpts,
      );
    });
  }
};
